import React from 'react'

const ArrowIcon = ({ position = 'bottom' }) => {
  const rotate = position === 'bottom' ? '0deg' : '180deg'
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `rotate(${rotate})` }}
    >
      <g opacity="0.58">
        <path
          d="M7 10L12 15L17 10"
          stroke="#130F26"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  )
}
export default ArrowIcon
